<ng-container *transloco="let t">
  <div class="position-relative">
    <div class="date-picker w-100">
      <div class="input-group w-0 h-0">
        <input
          name="datepicker"
          ngbDatepicker
          #dateRangePicker="ngbDatepicker"
          [autoClose]="'outside'"
          (dateSelect)="onDateSelection($event)"
          [displayMonths]="2"
          [dayTemplate]="dayTemplate"
          outsideDays="hidden"
          [startDate]="filterForm.get('dateStart')?.value"
          tabindex="-1"
          class="border-0 h-0 date-picker-input"
        />
        <ng-template #dayTemplate let-date let-focused="focused">
          <span
            class="custom-day"
            [class.focused]="focused"
            [class.range]="isRange(date)"
            [class.start]="isStart(date)"
            [class.end]="isEnd(date)"
            [class.faded]="isHovered(date) || isInside(date)"
            (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null"
          >
            {{ date.day }}
          </span>
        </ng-template>
      </div>
    </div>
    <div class="input-group" [class.active]="isSelected" [class.opened]="dateRangePicker.isOpen()">
      <div class="input-group-prepend prepend-rounded">
        <span class="material-symbols-rounded fs-20 text-black-100" (click)="dateRangePicker.toggle()"> calendar_month </span>
      </div>
      <input
        name="dateRange"
        class="form-control form-control-rounded black-placeholder fw-medium"
        [value]="dateRangeLabel"
        [placeholder]="t('shared/dateRangeFilter')"
        (click)="dateRangePicker.toggle()"
        readonly
      />
      <div *ngIf="isSelected" class="input-group-append append-rounded">
        <span class="material-symbols-rounded fs-18 text-black-100" role="button" (click)="onClearDate()"> close </span>
      </div>
    </div>
  </div>
</ng-container>
